<script>
import { GlobalBus } from '@services/bus'
import { MODAL, RELOAD } from '@constants/Text'
import store from '@state/store'
import P from '@services/parameters'

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Remetente',
    },
    dontAcceptAAWZ: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // email: {
      //   email: 'aawz@aawz.com.br',
      //   validated: true,
      // },
      email: 'aawz@aawz.com.br',
      countKey: 0,
    }
  },
  computed: {
    emails() {
      if (this.dontAcceptAAWZ) {
        return store.getters['user/emails'].filter((e) => {
          return e.email !== 'aawz@aawz.com.br'
        })
      } else {
        return store.getters['user/emails']
      }
    },
    hasInvalid() {
      return this.emails.some((v) => {
        return !v.validated
      })
    },
  },
  watch: {
    emails(val) {
      if (val.length > (this.dontAcceptAAWZ ? 0 : 1)) {
        const em =
          val.find((a) => {
            return a.validated
          }) || {}
        this.email = em.email
        this.$emit('input', em.email)
      }
    },
  },
  created() {
    if (this.emails.length) {
      const em =
        this.emails.find((a) => {
          return a.validated
        }) || {}
      this.$emit('input', em.email || 'aawz@aawz.com.br')
      this.email = em.email || 'aawz@aawz.com.br'
    } else {
      this.$emit('input', 'aawz@aawz.com.br')
    }

    if (this.dontAcceptAAWZ) {
      this.email = ''
    }
    this.coletarEmails()
    GlobalBus.$on(RELOAD.VALIDAR_EMAIL, this.coletarEmails)
  },
  mounted() {
    globalThis.addEventListener('click', this.blurEmailSelect)
  },
  beforeDestroy() {
    globalThis.removeEventListener('click', this.blurEmailSelect)
    GlobalBus.$off(RELOAD.VALIDAR_EMAIL, this.coletarEmails)
  },
  methods: {
    blurEmailSelect() {
      if (this.$refs.select) {
        this.$refs.select.blur()
      }
    },
    updateEmail() {
      this.$emit('input', this.email)
    },
    addNew() {
      console.log('teste')
      this.$refs.select.blur()
      this.countKey = this.countKey + 1
      GlobalBus.$emit(MODAL.VALIDAR_EMAIL, true)
    },
    coletarEmails() {
      P.getEmails()
    },
  },
}
</script>

<template>
  <div style="width: 100%" class="v-application" data-app @click.stop>
    <v-select
      :key="countKey"
      ref="select"
      v-model="email"
      :label="label"
      item-value="email"
      item-text="email"
      hide-details
      :items="emails"
      :item-disabled="
        (v) => {
          return !v.validated
        }
      "
      @change="updateEmail"
    >
      <template v-slot:item="{ item, on }">
        <div
          disabled
          class="d-flex align-items-center"
          style="justify-content: space-between; width: 100%;"
          v-on="on"
        >
          <p class="mb-0">{{ item.email }}</p>
          <small class="text-secondary">{{
            item.validated ? 'Válido' : 'Aguardando validação'
          }}</small>
        </div>
      </template>

      <template v-if="hasInvalid" v-slot:append-item>
        <v-divider />
        <div
          class="pad v-list-item v-list-item--link theme--light"
          @click="addNew"
        >
          Validar meu e-mail
        </div>
      </template>
    </v-select>
  </div>
</template>

<style lang="sass" scope>
.pad
  padding: 0px 16px
</style>
